import { Mail, Building2, ShieldCheck, ArrowUpRight } from "lucide-react";
import { SEO } from "@/components/SEO";

const EMAIL = "info@deltapictures.it";
const LEGAL = [
  { label: "Privacy Policy", href: "https://www.deltapictures.it/privacy-policy/" },
  { label: "Cookie Policy", href: "https://www.deltapictures.it/cookie-policy/" },
  { label: "Disclaimer", href: "https://www.deltapictures.it/disclaimer/" },
];

const Block = ({ icon: Icon, title, children, testid }) => (
  <section data-testid={testid} className="rounded-2xl border border-hair bg-surfaceSecondary p-6">
    <div className="flex items-center gap-3 mb-3">
      <span className="w-10 h-10 rounded-full bg-brand/10 text-brand flex items-center justify-center"><Icon size={19} /></span>
      <h2 className="font-serif text-xl font-semibold text-onSurface">{title}</h2>
    </div>
    <div className="text-base leading-relaxed text-onSurfaceSecondary">{children}</div>
  </section>
);

export default function Contatti() {
  return (
    <div data-testid="contatti-page" className="max-w-[860px] mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-14 pb-16">
      <SEO title="Contatti" description="Contatti di Readoo, il progetto di Delta Pictures: scrivici per informazioni, segnalazioni e collaborazioni." />
      <p className="font-mono text-[11px] font-bold uppercase tracking-wider text-brand mb-3">Contatti</p>
      <h1 className="font-serif text-4xl sm:text-5xl font-semibold leading-tight text-onSurface">Chi c’è dietro Readoo</h1>
      <p className="mt-4 text-base sm:text-[17px] leading-relaxed text-onSurfaceSecondary max-w-2xl">
        Readoo è un progetto di Delta Pictures: ogni giorno ti aiuta a scegliere cosa leggere e offre vantaggi riservati ai lettori registrati.
      </p>
      <div className="mt-8 grid gap-4">
        <Block icon={Mail} title="Scrivici" testid="contatti-email-block">
          <p>Per informazioni, segnalazioni sui contenuti, collaborazioni o richieste sul tuo account:</p>
          <a href={`mailto:${EMAIL}`} data-testid="contatti-email" className="mt-2 inline-flex items-center gap-1.5 font-semibold text-brand hover:underline break-all">{EMAIL}</a>
        </Block>
        <Block icon={Building2} title="Editore" testid="contatti-publisher-block">
          <p>Readoo è realizzato da <span className="font-semibold text-onSurface">Delta Pictures S.r.l.</span></p>
          <dl data-testid="contatti-company" className="mt-3 grid grid-cols-[auto,1fr] gap-x-4 gap-y-1 text-sm">
            <dt className="text-subtle">Sede</dt><dd>Via G. Boglietti 2, 13900 Biella</dd>
            <dt className="text-subtle">P. IVA</dt><dd>02154000026</dd>
            <dt className="text-subtle">R.E.A.</dt><dd>BI 181760</dd>
            <dt className="text-subtle">Cap. Soc.</dt><dd>€ 50.000 i.v.</dd>
          </dl>
          <a href="https://www.deltapictures.it/" target="_blank" rel="noopener noreferrer" data-testid="contatti-publisher-link" className="mt-2 inline-flex items-center gap-1 font-semibold text-brand hover:underline">
            Scopri Delta Pictures <ArrowUpRight size={15} />
          </a>
        </Block>
        <Block icon={ShieldCheck} title="Privacy e dati personali" testid="contatti-privacy-block">
          <p>Per esercitare i tuoi diritti sui dati personali scrivi a <a href={`mailto:${EMAIL}`} className="font-semibold text-brand hover:underline">{EMAIL}</a>. Trovi tutti i dettagli nei documenti legali:</p>
          <ul className="mt-2 flex flex-wrap gap-x-5 gap-y-1">
            {LEGAL.map((l) => (
              <li key={l.label}>
                <a href={l.href} target="_blank" rel="noopener noreferrer" data-testid={`contatti-legal-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="inline-flex items-center gap-1 font-semibold text-brand hover:underline">
                  {l.label} <ArrowUpRight size={14} />
                </a>
              </li>
            ))}
          </ul>
        </Block>
      </div>
    </div>
  );
}
